export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE;
export const SENTRY_PROFILES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE;
export const SENTRY_REPLAYS_SESSION_SAMPLE_RATE = import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE;
export const SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE = import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;
export const SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED;
export const SENTRY_ATTACH_STACKTRACE = import.meta.env.VITE_SENTRY_ATTACH_STACKTRACE;